var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('video',{staticClass:"video",attrs:{"src":require("../assets/video/banner.mp4"),"autoplay":"","muted":"","loop":""},domProps:{"muted":true}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-font"},[_c('div',{staticClass:"font-english"},[_vm._v("SCIENCE MOVEMENT LEADER")]),_c('div',{staticClass:"font-chinese"},[_vm._v("科学运动引领者")])])
}]

export { render, staticRenderFns }